import { useContext } from "react"
import Modal from "react-responsive-modal"
import { Toast, ToastContainer } from "react-bootstrap"
import VicinityContext from "../context/vicinityContext"
import { CommunityMemberAdd } from "./CommunityMemberAdd"
import { EditCommunityMemberModal } from "./EditCommunityMemberModal"
import { EditCommunitySettingsModal } from "./EditCommunitySettingsModal"
import SidebarDashboard from "./shared/SidebarDashboard"

// The Members sidebar with its toasts and member/community modals.
// `manager` comes from useCommunityManager().
export default function CommunitySidebar({ manager }) {
    const { notifications, setShowNotificationModal } =
        useContext(VicinityContext)
    const {
        communities,
        isLoadingCommunities,
        isSidebarOpen,
        setIsSidebarOpen,
        toasts,
        addToast,
        removeToast,
        handleRefreshCommunities,
        openAddMemberModal,
        addCommunityMember,
        closeAddMemberModal,
        handleAddMemberSubmit,
        handleRemoveMember,
        handleDeleteCommunity,
        openEditMemberModal,
        editingMember,
        editCommunityMember,
        closeEditMemberModal,
        handleEditCommunityMemberSubmit,
        openCommunitySettingsModal,
        editingCommunity,
        editCommunitySettings,
        closeCommunitySettingsModal,
        handleCommunitySettingsSubmit,
        reorderChaperees,
        togglePinMember,
    } = manager

    return (
        <>
            <ToastContainer
                position="middle-start"
                className="p-3"
                style={{ zIndex: 9999 }}
            >
                {toasts.map((toast) => (
                    <Toast
                        key={toast.id}
                        onClose={() => removeToast(toast.id)}
                        bg="dark"
                        autohide
                        delay={5000}
                    >
                        <Toast.Header>
                            <strong className="me-auto">Notification</strong>
                        </Toast.Header>
                        <Toast.Body className="text-white">
                            {toast.message}
                        </Toast.Body>
                    </Toast>
                ))}
            </ToastContainer>

            {/* Community Member Add Modal */}
            <Modal
                open={openAddMemberModal}
                onClose={closeAddMemberModal}
                center
            >
                <CommunityMemberAdd
                    onClose={closeAddMemberModal}
                    onSubmit={handleAddMemberSubmit}
                    addToast={addToast}
                />
            </Modal>

            {/* Edit Community Member Modal */}
            <Modal
                open={openEditMemberModal}
                onClose={closeEditMemberModal}
                center
            >
                {editingMember && (
                    <EditCommunityMemberModal
                        onClose={closeEditMemberModal}
                        onSubmit={handleEditCommunityMemberSubmit}
                        member={editingMember}
                        communityId={editingMember.communityId}
                    />
                )}
            </Modal>

            {/* Community Settings Modal */}
            <Modal
                open={openCommunitySettingsModal}
                onClose={closeCommunitySettingsModal}
                center
            >
                {editingCommunity && (
                    <EditCommunitySettingsModal
                        onClose={closeCommunitySettingsModal}
                        onSubmit={handleCommunitySettingsSubmit}
                        community={editingCommunity}
                    />
                )}
            </Modal>

            {/* Floating Dashboard Sidebar */}
            <SidebarDashboard
                notifications={notifications}
                communities={communities}
                isLoadingCommunities={isLoadingCommunities}
                addCommunityMember={addCommunityMember}
                removeCommunityMember={handleRemoveMember}
                deleteCommunity={handleDeleteCommunity}
                editCommunitySettings={editCommunitySettings}
                editCommunityMember={editCommunityMember}
                reorderChaperees={reorderChaperees}
                togglePinMember={togglePinMember}
                isSidebarOpen={isSidebarOpen}
                setIsSidebarOpen={setIsSidebarOpen}
                onShowNotifications={() => setShowNotificationModal(true)}
                refreshCommunities={handleRefreshCommunities}
            />
        </>
    )
}
